// extracted by mini-css-extract-plugin
export default {"NavButton":"NavButton_NavButton__ZI8Uq","Selected":"NavButton_Selected__C9Kc5","Label":"NavButton_Label__yL1hO"};